import {useEffect, useRef, useState} from 'react';
import {Link, useParams} from 'react-router-dom';

import {useDispatch, useSelector} from 'react-redux';
import HeaderBtn from '../../../components/headerBtn/headerBtn';

import '../../../scss/App.scss';
import {IUserOptions} from '../../../types/interfaces';
import Sidebar from "../../../components/sidebar/Sidebar";
import SectionContent from "../../../components/sectionContent/sectionContent";
import clsx from "clsx";
import Loader from "../../../components/custom/loader/loader";
import {actionGetContractInfo} from "../../../redux/action/userSingleReport/actionUserSingleReport";
import {AppDispatch} from "../../../redux/reducer/store";
import {actionGetServiceTypesSelect} from "../../../redux/action/easymerch/actionServiceTypes";

const CustomerContractsInfoSection = () => {
    const dispatch = useDispatch<AppDispatch>();
    const {id} = useParams<{ id: string }>();

    const {selectContactById,} = useSelector((state: any) => state.easymerch.serviceTypes);

    const {contractInfo} = useSelector((state: any) => state.userSingleReport.userSingleReport);

    const {claims} = useSelector((state: IUserOptions) => state.user.user.data);

    const {isOpenSidebar} = useSelector(
        (state: IUserOptions) => state.user.user,
    );
    const [isPending, setIsPending] = useState<boolean>(true);

    const buttonsContainerRef = useRef<any>(null);

    const [overflowedBtnsCount] = useState<number>(0);
    const [isOpenGroupBtn] = useState<boolean>(false);

    const availableButtons = [
        {
            claims: [],
            component: (
                <HeaderBtn
                    content='Вернуться к списку'
                    purpose='navigateToContractsList'
                    modalTitle='Возврат к списку контрактов'
                />
            ),
        },
    ];

    const filteredAvailableButtons = availableButtons.filter((btn: any) => {
        return btn.claims?.length > 0
               ? btn.claims.filter((claim: any) => claims.includes(claim)).length > 0
               : true;
    });

    const displayedAvailableBtns = filteredAvailableButtons
        ?.slice(-(overflowedBtnsCount as number))
        ?.map((elem: any, index: number) => {
            return elem && <div key={index}>{elem?.component}</div>;
        });

    const displayedHeadBtns = filteredAvailableButtons
        ?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
        ?.map((elem: any, index: number) => {
            return elem && <div key={index}>{elem?.component}</div>;
        });

    useEffect(() => {
        if (!selectContactById) {
            setIsPending(true);
            dispatch(actionGetServiceTypesSelect()).then(() => {
                setIsPending(false);
            });
        }
    }, [selectContactById, dispatch]);

    useEffect(() => {
        if (id) {
            const contractId = parseInt(id ? id : '0')
            dispatch(actionGetContractInfo(contractId)).then(() => {
                setIsPending(false);
            });
        }
    }, [id, dispatch]);

    return (
        <div className='App'>
            <Sidebar/>
            <SectionContent
                buttonsContainerRef={buttonsContainerRef}
                headBlockChildren={displayedHeadBtns}
                isOpenGroupBtn={isOpenGroupBtn}
                availableButtons={displayedAvailableBtns}
                title={selectContactById && id && selectContactById[id]}
                pageName='contractsInfo'
                section='Контракт'
            >
                <div className='content__main'>
                    <div
                        className={clsx(
                            isOpenSidebar && 'btns_active',
                            !isOpenSidebar && 'btns_close',
                            'btns',
                        )}
                    >
                        <Link to={`/contracts/${id}/info`} className='tab'>
                            <div className='buttons__btn  --active'>Информация</div>
                        </Link>
                    </div>
                    <div className='loader__wrapper'>
                        {isPending && <Loader/>}
                    </div>
                    {contractInfo && contractInfo?.gammaUrl ? (
                        <div className='table__wrapper'>
                            <table className='flexible-table'>
                                <thead>
                                <tr className='clients__list_head'>
                                    <th>Информация по контракту</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>
                                        <div>
                                            <iframe src={contractInfo?.gammaUrl}
                                                    className="gamma_iframe"
                                                    allow="fullscreen"
                                                    title="Презентация по контракту">
                                            </iframe>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="block__info">В настоящее время отсутствует информация по контракту</div>
                     )}
                </div>
            </SectionContent>
        </div>
    );
};

export default CustomerContractsInfoSection;
